import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { getMessageProps, messageIdExists } from 'Store/reducers';

class ConnectedInjectIntl extends React.Component {
  render() {
    return (
      <React.Fragment>{this.props.render(this.props.messages)}</React.Fragment>
    );
  }
}

const mapStateToProps = (state, { intl, messageIds }) => {
  if (!Array.isArray(messageIds) || messageIds.length === 0) return {};
  const messages = {};
  messageIds.map(id => {
    if (!messageIdExists(state, id)) return;
    messages[id] = intl.formatMessage(getMessageProps(state, id));
  });
  return { messages };
};

export default injectIntl(connect(mapStateToProps)(ConnectedInjectIntl));
